import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuX } from "react-icons/lu";
import { SMART_ELEMENT_CONFIGS } from "../../../../../plugins/AtomicBoxPlugin/atomic_box_plugin_config";
import { addAtomicBox } from "../elementActions";
import AssetGrid from "../ui/AssetGrid";
import AssetCell from "../ui/AssetCell";
import ElementPreview from "./ElementPreview";
import RealElementPreview from "./RealElementPreview";
import "./_panel.scss";
import "./_elementsPanel.scss";

const SMART_GROUPS = ["Text", "Lists", "Layout", "Data & Media", "UI"];

const SmartElementsPanel = (props) => {
  const {
    boxes,
    boxSelected,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    onBoxAdded,
    onClose,
  } = props;

  const ctx = {
    boxes,
    boxSelected,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    onBoxAdded,
  };

  const renderCard = (cfg) => {
    const label = i18n.t(`SmartElements_Types_${cfg.type.replace(/-/g, "_")}`, {
      defaultValue: cfg.displayName,
    });
    return (
      <AssetCell
        key={cfg.type}
        dragProps={{
          className: "palette-item floatingEditorBox",
          name: "AtomicBoxPlugin",
          "data-plugin": "AtomicBoxPlugin",
          "data-atomic-type": cfg.type,
          "data-schematic": "1",
        }}
        ratio={0.82}
        title={label}
        label={label}
        onAdd={() => addAtomicBox(cfg.type, ctx)}
        dragPreview={<RealElementPreview kind={cfg.type} />}
      >
        <ElementPreview kind={cfg.type} icon={cfg.icon} />
      </AssetCell>
    );
  };

  return (
    <div className="cmp-panel">
      <div className="cmp-panel__toolbar">
        <span className="cmp-panel__title">{i18n.t("smart_elements") || "Akıllı Öğeler"}</span>
        {onClose && (
          <button
            type="button"
            className="cmp-panel__close"
            onClick={onClose}
            title={i18n.t("close")}
          >
            <LuX size={15} />
          </button>
        )}
      </div>

      <div className="cmp-panel__scroll">
        <div className="cmp-el-list">
          {SMART_GROUPS.map((group) => {
            const items = SMART_ELEMENT_CONFIGS.filter((cfg) => cfg.group === group);
            if (!items.length) return null;
            const groupLabel = i18n.t(
              `SmartElements_Groups_${group.replace(/\s+/g, "").replace(/&/g, "")}`,
              { defaultValue: group }
            );
            return (
              <div key={group} className="cmp-el-group">
                <div className="cmp-el-group__subtitle">{groupLabel}</div>
                <AssetGrid columns={2} cellSize={118} gap={10}>
                  {items.map(renderCard)}
                </AssetGrid>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

SmartElementsPanel.propTypes = {
  boxes: PropTypes.object.isRequired,
  boxSelected: PropTypes.any,
  navItems: PropTypes.object.isRequired,
  navItemSelected: PropTypes.any.isRequired,
  containedViews: PropTypes.object.isRequired,
  containedViewSelected: PropTypes.any.isRequired,
  onBoxAdded: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

export default SmartElementsPanel;
